import { render, staticRenderFns } from "./AdminInsert.vue?vue&type=template&id=0914b212&scoped=true&"
import script from "./AdminInsert.vue?vue&type=script&lang=js&"
export * from "./AdminInsert.vue?vue&type=script&lang=js&"
import style0 from "./AdminInsert.vue?vue&type=style&index=0&id=0914b212&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0914b212",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
